import { ContainerModule } from 'inversify';
import practiceStoreModule, { PracticeStoreModuleSymbol } from './practice-store-module';

export const practiceStoreContainerModule = new ContainerModule((bind) => {
  bind(PracticeStoreModuleSymbol).toConstantValue(practiceStoreModule)
});
